export const exportHeaders = [
    { 
        label: "Customer Account Number", 
        key:"Customer_Account.customer_account_number" 
    },
    {
        label: "Billing Account Number",
        key: "Customer_Account.customer_billto_account_number",
    },
    { 
        label: "Sales Division Code", 
        key: "Customer_Account.customer_sales_division_code" 
    },
    { 
        label: "Market Class Code", 
        key: "Customer_Account.market_class_code" 
    },
    { 
        label: "Segment Code", 
        key: "Customer_Account.segment_code" 
    },
    { 
        label: "Status", 
        key: "approval_status"
    },
]

export const exportapprovalHeaders = [
    { 
        label: "Customer Account Number", 
        key:"Customer_Account.customer_account_number" 
    },
    {
        label: "Billing Account Number",
        key: "Customer_Account.customer_billto_account_number",
    },
    { 
        label: "Sales Division Code", 
        key: "Customer_Account.customer_sales_division_code" 
    },
    { 
        label: "Market Class Code", 
        key: "Customer_Account.market_class_code" 
    },
    { 
        label: "Segment Code", 
        key: "Customer_Account.segment_code" 
    },
    { 
        label: "Type", 
        key: "One_Web_Request.type"
    },
]

